/* eslint-disable no-undef */
import { history } from '../index';

export function historyPush(path) {
  const marketplace_uid = localStorage.getItem('user.marketplace.uid');

  history.push(`${process.env.PUBLIC_URL}/${marketplace_uid}${path}`);
}

export function historyReplace(path) {
  const marketplace_uid = localStorage.getItem('user.marketplace.uid');

  history.replace(`${process.env.PUBLIC_URL}/${marketplace_uid}${path}`);
}
